<template>
    <div>
        <b-row class="toolbar-ptc">
            <b-col>
                <router-link :to="{ name: 'member_info_list', params: { search:$route.params.search } }" class="btn btn-ptc1" tag="button">返回</router-link>
            </b-col>
            <b-col class="text-center title">會員管理 / 會員查詢 / 會員資料({{this.$route.params.membername}})</b-col>
            <b-col>
                <div class="float-right">
                  <button type="button" class="btn btn-danger" @click="checkDelete()" v-if="FunctionPermission==4">刪除</button>
                </div>
            </b-col>
        </b-row>
        <div id="func-content">
            <div class="contact-page">
                <div class="row">
                    <div class="col-lg-12">
                        <b-card class="bg-default-card">
                            <div class="row">
                                <div class="col-lg-12">
                                    <div class="p-4 box-shadow" header="Form Elements">
                                        <div class="row">
                                            <b-tabs class="col-lg-12">
                                                <b-tab title="基本資料" active>
                                                    <div class="col-lg-12 col-12 mb-3">
                                                        <vue-form class="form-horizontal form-validation" :state="formstate">
                                                            <div>
                                                                <div class="row col-lg-12">
                                                                    <div class="col-lg-3">
                                                                        <validate tag="div">
                                                                            <label for="name"> 姓名</label>
                                                                            <input v-model="member.Name" id="name" name="username" type="text" required autofocus placeholder="User Name" class="form-control" disabled/>
                                                                        </validate>
                                                                    </div>
                                                                    <div class="col-lg-3">
                                                                        <validate tag="div">
                                                                            <label for="gender">性別</label>
                                                                            <select id="gender" name="gender" size="1" class="form-control" v-model="member.Gender" required checkbox disabled>
                                                                                <option value="male">男</option>
                                                                                <option value="female">女</option>
                                                                                <option value="private">不公開</option>
                                                                            </select>
                                                                        </validate>
                                                                    </div>
                                                                    <div class="col-lg-3">
                                                                        <div class="form-group">
                                                                            <validate tag="div">
                                                                                <label for="dob">生日</label>
                                                                                <input name="dob" id="dob" type="date" required placeholder="Date of Birth" class="form-control" v-model="member.Birthday" disabled/>
                                                                            </validate>
                                                                        </div>
                                                                    </div>
                                                                    <div class="col-lg-3">
                                                                        <validate tag="div">
                                                                            <label for="mobile"> 手機號碼</label>&nbsp;
                                                                            <button v-if="!hideEditFields.edit_mobile" type="button" class="btn btn-outline-light btn-sm" @click="editmobile()">修改號碼</button>&nbsp;
                                                                            <button v-if="hasLogList === true" type="button" title="手機號碼修改歷程" class="btn-circle btn-circle-ptc1 btn-sm" @click="showMobileUpdateLog()"><span class="fa fa-search-plus"></span></button>
                                                                            <input v-model="member.Mobile" name="mobile" disabled id="mobile" type="mobile" required placeholder="Mobile Number(10 Digits)" class="form-control" pattern="[0-9]{10}" />
                                                                            <field-messages name="mobile" show="$invalid && $submitted" class="text-danger">
                                                                                <div slot="required">Mobile number is a required field</div>
                                                                                <div slot="pattern">Mobile number is not valid</div>
                                                                            </field-messages>
                                                                        </validate>
                                                                    </div>
                                                                    <div class="col-lg-3">
                                                                        <validate tag="div">
                                                                            <label for="level"> 目前等級</label>
                                                                            <input v-model="member.GradeText" id="level" name="level" type="text" required autofocus class="form-control" disabled/>
                                                                        </validate>
                                                                    </div>
                                                                    <div class="col-lg-3">
                                                                        <validate tag="div">
                                                                            <label for="up_level_time"> 入會日期</label>
                                                                            <input v-model="member.CreatedAt" id="up_level_time" name="up_level_time" type="text" required autofocus class="form-control" disabled/>
                                                                        </validate>
                                                                    </div>
                                                                    <div class="col-lg-3">
                                                                        <validate tag="div">
                                                                            <label for="up_level_time"> 升等日期</label>
                                                                            <input v-model="member.UpgradeAt" id="up_level_time" name="up_level_time" type="text" required autofocus class="form-control" disabled/>
                                                                        </validate>
                                                                    </div>
                                                                </div>
                                                                <div class="col-lg-12">
                                                                    <div class="form-group">
                                                                        <validate tag="div">
                                                                            <label for="email"> E-mail</label>
                                                                            <input v-model="member.Email" name="email" id="email" type="email" required placeholder="E-mail" class="form-control" disabled/>
                                                                        </validate>
                                                                    </div>
                                                                </div>
                                                                <div class="row col-lg-12">
                                                                    <div class="col-lg-2">
                                                                        <div class="form-group">
                                                                            <validate tag="div">
                                                                                <label for="city">城市</label>
                                                                                <select id="city" name="city" required size="1" class="form-control" checkbox v-model="member.City" disabled>
                                                                                    <option v-for="v in city" :key="v.id" :value="v" selected>{{ v.city }}</option>
                                                                                </select>
                                                                            </validate>
                                                                        </div>
                                                                    </div>
                                                                    <div class="col-lg-2">
                                                                        <div class="form-group">
                                                                            <validate tag="div">
                                                                                <label for="erea">區域</label>
                                                                                <select id="erea" name="erea" required size="1" class="form-control" checkbox v-model="member.District" disabled>
                                                                                    <option v-for="v1 in member.City.districts" :key="v1.name" :value="v1.name" selected>{{ v1.name }} </option>
                                                                                </select>
                                                                            </validate>
                                                                        </div>
                                                                    </div>
                                                                    <div class="col-lg-6">
                                                                        <div class="form-group">
                                                                            <validate tag="div">
                                                                                <label for="address">地址</label>
                                                                                <input id="address" name="address" type="text" required autofocus placeholder="address" class="form-control" v-model="member.Address" disabled/>
                                                                            </validate>
                                                                        </div>
                                                                    </div>
                                                                    <div class="row col-lg-12">
                                                                        <div class="form-group col-lg-4">
                                                                            <validate tag="div">
                                                                                <label for="OneAssetsSn">推薦碼</label>
                                                                                <input v-model="member.ReferralCode" id="OneAssetsSn" name="OneAssetsSn" type="text" required autofocus disabled class="form-control"/>
                                                                            </validate>
                                                                        </div>
                                                                        <div class="form-group col-lg-3">
                                                                            <validate tag="div">
                                                                                <label for="Referrer">推薦人</label>
                                                                                <input v-model="member.MemberReference.MemberName" id="Referrer" name="Referrer" type="text" required autofocus disabled class="form-control"/>
                                                                            </validate>
                                                                        </div>
                                                                    </div>
                                                                    <div class="row col-lg-12">
                                                                        <div class="form-group col-lg-3">
                                                                            <validate tag="div">
                                                                                <label for="Referrer">累積總點數</label>
                                                                                <input v-model="member.Accumulated" id="Point" name="Point" type="nember" required autofocus disabled class="form-control"/>
                                                                            </validate>
                                                                        </div>
                                                                        <div class="form-group col-lg-3">
                                                                            <validate tag="div">
                                                                                <label for="Referrer">可用點數</label>
                                                                                <input v-model="member.AvailableBonus" id="Point" name="Point" type="nember" required autofocus disabled class="form-control"/>
                                                                            </validate>
                                                                        </div>
                                                                        <div class="form-group col-lg-3">
                                                                            <validate tag="div">
                                                                                <label for="Referrer">今年底到期點數</label>
                                                                                <input v-model="member.YearExpiredBonus" id="Point" name="Point" type="nember" required autofocus disabled class="form-control"/>
                                                                            </validate>
                                                                        </div>
                                                                    </div>
                                                                    <div class="col-lg-12 row mb-3">
                                                                      <div class="col-lg-3">
                                                                        <label>狀態:</label>
                                                                        <div class="row">
                                                                          <label class="ml-3 mr-auto">
                                                                              <input class="radiobox-boom" v-model="member.Status" type="radio" name="x" value="1" disabled> 正常
                                                                          </label>
                                                                          <label>
                                                                              <input class="radiobox-boom" v-model="member.Status" type="radio" name="x" value="2" disabled> 黑名單
                                                                          </label>
                                                                        </div>
                                                                      </div>
                                                                      <div class="col-lg-3">
                                                                        <validate tag="div">
                                                                          <label for="status_updated_by"> 最後修改人員</label>
                                                                          <input v-model="member.StatusUpdatedAccount" id="status_updated_by" type="text" required autofocus class="form-control" disabled/>
                                                                        </validate>
                                                                      </div>
                                                                      <div class="col-lg-3">
                                                                        <validate tag="div">
                                                                            <label for="status_updated_at"> 最後修改時間</label>
                                                                            <input v-model="member.StatusUpdatedAt" id="status_updated_at" type="text" required autofocus class="form-control" disabled/>
                                                                        </validate>
                                                                      </div>
                                                                      <div v-if="member.Status == 2" class="col-lg-3">
                                                                        <label for="status_updated_at"> 備註</label>
                                                                        <input v-model="member.BlackListComment" id="black_covent" name="black_covent" type="text" required autofocus  class="form-control" disabled/>
                                                                      </div>
                                                                    </div>
                                                                    <div class="col-lg-12 row">
                                                                      <div class="col-lg-3">
                                                                        <label>臨櫃付款黑名單狀態:</label>
                                                                        <div class="row">
                                                                          <label class="ml-3 mr-auto">
                                                                              <input class="radiobox-boom" v-model="member.StorepayBlackStatus" type="radio" name="storepay_black" value="1" disabled> 正常
                                                                          </label>
                                                                          <label>
                                                                              <input class="radiobox-boom" v-model="member.StorepayBlackStatus" type="radio" name="storepay_black" value="2" disabled> 黑名單
                                                                          </label>
                                                                        </div>
                                                                      </div>
                                                                      <div class="col-lg-3">
                                                                        <validate tag="div">
                                                                          <label for="storepay_black_updated_by"> 最後修改人員</label>
                                                                          <input v-model="member.StorepayBlackStatusUpdatedAccount" id="storepay_black_updated_by" type="text" required autofocus class="form-control" disabled/>
                                                                        </validate>
                                                                      </div>
                                                                      <div class="col-lg-3">
                                                                        <validate tag="div">
                                                                            <label for="storepay_black_updated_at"> 最後修改時間</label>
                                                                            <input v-model="member.StorepayBlackStatusUpdatedAt" id="storepay_black_updated_at" type="text" required autofocus class="form-control" disabled/>
                                                                        </validate>
                                                                      </div>
                                                                    </div>
                                                                    <div class="float-right">
                                                                        <b-btn variant="primary" @click="editcontact(member)" v-show="FunctionPermission >= 2">修改</b-btn>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </vue-form>
                                                    </div>
                                                </b-tab>
                                                <b-tab title="電子券" >
                                                  <b-card class="bg-default-card">
                                                    <div class="row">
                                                      <input type="text" class="form-control col-lg-3 md-1" id="text" v-model="giftcertificate.keyword" placeholder="關鍵字(代號、名稱、類別)">
                                                      <button type="button" class="btn text-white btn-warning" @click="getgiftcertificate(1)">查詢</button>
                                                    </div>
                                                    <div class="col-lg-3 row">
                                                    </div>
                                                    <div class="col-lg-12">
                                                        <table  id="mytable" class="table table-bordred table-striped mt-2">
                                                            <tr>
                                                                <th>代號</th>
                                                                <th>名稱</th>
                                                                <th>類別</th>
                                                                <th>點數兌換票券日期</th>
                                                                <th>有效日期</th>
                                                            </tr>
                                                            <tr v-for="v in giftcertificatelist" :key="v.ID">
                                                                <td>{{v.Code}}</td>
                                                                <td>{{v.Name}}</td>
                                                                <td>{{v.Types}}</td>
                                                                <td>{{v.CreatedAt|formatDate}}</td>
                                                                <td>{{v.ExpiredEndAt|YYYYMMDD}}</td>
                                                            </tr>
                                                        </table>
                                                        <div class="row" style="padding: 0 1rem">
                                                            <b-pagination size="md" :total-rows="giftcertificate.totalrows" v-model="giftcertificate.currentPage" :per-page="giftcertificate.rows" @change="getgiftcertificate"></b-pagination>
                                                            <label style="margin:8px">{{giftcertificate.startRowNum}}到{{giftcertificate.endRowNum}}，總共 {{giftcertificate.totalrows}}筆</label>
                                                        </div>
                                                    </div>
                                                  </b-card>
                                                </b-tab>
                                                <b-tab title="推薦贈點">
                                                    <b-card class="bg-default-card">
                                                    <div class="row">
                                                      <input type="text" class="form-control col-lg-3" id="text" v-model="memberreference.keyword" placeholder="關鍵字(推薦好友、好友加入時間)">
                                                      <button type="button" class="btn text-white btn-warning" @click="getmemberreference(1)">查詢</button>
                                                    </div>
                                                    <table  id="mytable" class="table table-bordred table-striped mt-2">
                                                      <tr>
                                                        <th>推薦好友</th>
                                                        <th>好友加入時間</th>
                                                      </tr>
                                                      <tr v-for="v in memberreferencelist" :key="v.membername">
                                                        <td>{{v.FriendName}}</td>
                                                        <td>{{v.CreatedAt|formatDate}}</td>
                                                      </tr>
                                                    </table>
                                                    <div class="row" style="padding: 0 1rem">
                                                        <b-pagination size="md" :total-rows="memberreference.totalrows" v-model="memberreference.currentPage" :per-page="memberreference.rows" @change="getmemberreference"></b-pagination>
                                                        <label style="margin:8px">{{memberreference.startRowNum}}到{{memberreference.endRowNum}}，總共 {{memberreference.totalrows}}筆</label>
                                                    </div>
                                                  </b-card>
                                                </b-tab>
                                            </b-tabs>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </b-card>
                    </div>
                </div>
            </div>
        </div>
        <b-modal ref="editcontact" :no-close-on-backdrop="true" hide-footer title="會員資料修改" size="lg" @cancel="cancel">
            <div class="d-block">
                <div class="col-lg-12 col-12 mb-3">
                    <vue-form class="form-horizontal form-validation" :state="formstate1">
                        <div>
                            <div class="row col-lg-12">
                                <div class="col-lg-3">
                                    <validate tag="div">
                                        <label for="name1">姓名</label>
                                        <input v-model="model1.Name" id="name1" name="username1" type="text" required autofocus placeholder="User Name" class="form-control" :disabled=disabledEditFields.name1 />
                                    </validate>
                                </div>
                                <div class="col-lg-2">
                                    <validate tag="div">
                                        <label for="gender">性別</label>
                                        <select id="gender" name="gender" size="0" class="form-control" v-model="model1.Gender" required checkbox :disabled=disabledEditFields.gender >
                                            <option value="male">男</option>
                                            <option value="female">女</option>
                                            <option value="private">不公開</option>
                                        </select>
                                    </validate>
                                </div>
                                <div class="col-lg-4">
                                    <div class="form-group">
                                        <validate tag="div">
                                            <label for="dob">生日</label>
                                            <input name="dob" id="dob" type="date" required placeholder="Date of Birth" class="form-control" v-model="model1.Birthday" max="9999-12-31" :disabled=disabledEditFields.dob />
                                        </validate>
                                    </div>
                                </div>
                                <div class="col-lg-3">
                                    <validate tag="div">
                                        <label for="mobile"> 手機號碼<span style='color:red;' v-if="phonetype">請輸入正確手機碼</span></label>
                                        <input v-model="model1.Mobile" name="mobile" id="mobile" type="mobile" required placeholder="Mobile Number(10 Digits)" class="form-control" v-on:keyup="check_count($event)" disabled/>
                                        <field-messages name="mobile" show="$invalid && $submitted" class="text-danger">
                                            <div slot="required">Mobile number is a required field</div>
                                            <div slot="pattern">Mobile number is not valid</div>
                                        </field-messages>
                                    </validate>
                                </div>
                                <div class="col-lg-3">
                                    <validate tag="div">
                                        <label for="level"> 目前等級</label>
                                        <input v-model="model1.GradeText" id="level" name="level" type="text" required autofocus class="form-control" disabled/>
                                    </validate>
                                </div>
                                <div class="col-lg-4">
                                    <validate tag="div">
                                        <label for="up_level_time"> 入會日期</label>
                                        <input v-model="model1.CreatedAt" id="up_level_time" name="up_level_time" type="text" required autofocus class="form-control" disabled/>
                                    </validate>
                                </div>
                                <div class="col-lg-4">
                                    <validate tag="div">
                                        <label for="up_level_time"> 升等日期</label>
                                        <input v-model="model1.UpgradeAt" id="up_level_time" name="up_level_time" type="text" required autofocus class="form-control" disabled/>
                                    </validate>
                                </div>
                            </div>
                            <div class="col-lg-12">
                                <div class="form-group">
                                    <validate tag="div">
                                        <label for="email"> E-mail</label>
                                        <input v-model="model1.Email" name="email" id="email" type="email" required placeholder="E-mail" class="form-control" :disabled=disabledEditFields.email />
                                    </validate>
                                </div>
                            </div>
                            <div class="row col-lg-12">
                                <div class="col-lg-3">
                                  <div class="form-group">
                                    <validate tag="div">
                                      <label for="city">城市</label>
                                      <select id="city" name="city" required size="1" class="form-control" checkbox v-model="model1.City" @change="show(model1.City)" :disabled=disabledEditFields.city>
                                        <option value="">
                                            請選擇城市
                                        </option>
                                        <option v-for="v in city" :key="v.id" :value="v">{{ v.city }}</option>
                                      </select>
                                    </validate>
                                  </div>
                                </div>
                                <div class="col-lg-3">
                                    <div class="form-group">
                                        <validate tag="div">
                                            <label for="erea">區域</label>
                                            <select id="erea" name="erea" required size="1" v-model="model1.District" class="form-control" checkbox :disabled=disabledEditFields.erea >
                                                <option value="">
                                                    請選擇區域
                                                </option>
                                                <option v-for="v1 in districts1" :key="v1.name" :value="v1.name" selected>{{ v1.name }} </option>
                                            </select>
                                        </validate>
                                    </div>
                                </div>
                                <div class="col-lg-6">
                                    <div class="form-group">
                                        <validate tag="div">
                                            <label for="address">地址</label>
                                            <input id="address" name="address" type="text" required autofocus placeholder="address" class="form-control" v-model="model1.Address" :disabled=disabledEditFields.address />
                                        </validate>
                                    </div>
                                </div>
                                <div class="row col-lg-12">
                                    <div class="form-group col-lg-5">
                                        <validate tag="div">
                                            <label for="OneAssetsSn">推薦碼</label>
                                            <input v-model="model1.ReferralCode" id="OneAssetsSn" name="OneAssetsSn" type="text" required autofocus class="form-control" :disabled=disabledEditFields.OneAssetsSn />
                                        </validate>
                                    </div>
                                    <div class="form-group col-lg-3">
                                      <validate tag="div">
                                        <label for="Referrer">推薦人</label>
                                        <input v-model="model1.ReferralMemberName" id="Referrer" name="Referrer" type="text" required autofocus  class="form-control" disabled/>
                                      </validate>
                                    </div>
                                </div>
                                <div class="row col-lg-12">
                                    <div class="form-group col-lg-3">
                                      <validate tag="div">
                                        <label for="Referrer">累積總點數</label>
                                        <input v-model="model1.Accumulated" id="HistoryPoint" name="Point" type="nember" required autofocus disabled class="form-control"/>
                                      </validate>
                                    </div>
                                    <div class="form-group col-lg-3">
                                      <validate tag="div">
                                        <label for="Referrer">可用點數</label>
                                        <input v-model="model1.AvailableBonus" id="Point" name="Point" type="nember" required autofocus disabled class="form-control"/>
                                      </validate>
                                    </div>
                                    <div class="form-group col-lg-3">
                                      <validate tag="div">
                                        <label for="Referrer">今年底到期點數</label>
                                        <input v-model="model1.YearExpiredBonus" id="MaturityPoint" name="Point" type="nember" required autofocus disabled class="form-control"/>
                                      </validate>
                                    </div>
                                </div>
                                <div class="row col-lg-12">
                                    <label class="col-lg-3 mt-1">狀態:</label>
                                    <div class="col-lg-2 mt-1">
                                      <label>
                                        <input class="radiobox-boom" v-model="Status" type="radio" name="member_status" value="1" :disabled=disabledEditFields.member_status> 正常
                                      </label>
                                    </div>
                                    <div class="col-lg-2 mt-1">
                                      <label>
                                        <input class="radiobox-boom" v-model="Status" type="radio" name="member_status" value="2" :disabled=disabledEditFields.member_status > 黑名單
                                      </label>
                                    </div>
                                    <div class="col-lo-6">
                                      <input v-model="model1.BlackListComment" v-show="Status == 2" id="black_covent" name="black_covent" type="text" class="form-control"/>
                                    </div>
                                </div>
                                <div class="row col-lg-12">
                                    <label class="col-lg-3 mt-1">臨櫃付款黑名單狀態:</label>
                                    <div class="col-lg-2 mt-1">
                                      <label>
                                        <input class="radiobox-boom" v-model="model1.StorepayBlackStatus" type="radio" name="storepay_black" value="1" :disabled=disabledEditFields.storeoay_black > 正常
                                      </label>
                                    </div>
                                    <div class="col-lg-2 mt-1">
                                      <label>
                                        <input class="radiobox-boom" v-model="model1.StorepayBlackStatus" type="radio" name="storepay_black" value="2" :disabled=disabledEditFields.storeoay_black > 黑名單
                                      </label>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </vue-form>
                </div>
                <div class="cog-lg-12">
                    <div class="row float-right cog-lg-12">
                        <b-btn variant="primary"  @click="updateContact(model1)">儲存</b-btn>&nbsp;
                        <b-btn variant="secondary"  @click="cancel()">取消</b-btn>&nbsp;
                    </div>
                </div>
            </div>
        </b-modal>
        <!-- 編輯畫面Modal -->
      <b-modal ref="editmobile" hide-footer title='修改手機號碼'>
        <b-container fluid>
          <div class="row">
            <div class="col-lg-12">
              <div class='row mb-12'>
                <label class='control-label col-md-4'>新手機號碼：</label>
                  <div class='col-md-8'>
                    <input type='text' class='form-control' placeholder='請輸入新手機號碼' v-model.trim='newMobile' maxlength="10" >
                    <div class="text-danger" v-if="valid_newMobile">{{valid_newMobile}}</div>
                  </div>
              </div>
              <div class='row mb-12'>
                  <div class='col-md-12'>
                    <p></p>
                    1. 若會員忘記密碼，但手機號碼已更換，可用此功能幫會員更改手機號碼。<br />
                    2. 請先確認舊手機號碼已非本人持有；且新手機號碼為會員本人持有。<br />
                    3. 修改手機號碼後，會<span style='color:#FF8000;'>發一組新密碼到會員的新手機號碼</span>。
                    <p></p>
                  </div>
              </div>
              <div class="col-lg-12">
                    <div class="row float-right cog-lg-12">
                        <b-btn variant="primary" @click="checkMobile()">確定</b-btn>&nbsp;
                        <b-btn variant="secondary" @click="canceleditmobile()">取消</b-btn>&nbsp;
                    </div>
              </div>
            </div>
          </div>
        </b-container>
      </b-modal>
      <!-- 確認畫面Modal -->
      <b-modal ref="confirmMobile" hide-footer title='修改手機號碼'>
        <b-container fluid>
          <div class="row">
            <div class="col-lg-12">
              <div class='row mb-12'>
                  <div class='col-md-12'>
                    <p></p>
                    確定要將會員 {{member.Name}} 的手機號碼，從舊的{{member.Mobile}}，改成新的<span style='color:#FF8000;'>{{newMobile}}</span>?<p></p>
                  </div>
              </div>
              <div class="col-lg-12">
                    <div class="row float-right cog-lg-12">
                        <b-btn variant="primary" @click="checkUser()">確定</b-btn>&nbsp;
                        <b-btn variant="secondary" @click="cancelConfirmMobile()">取消</b-btn>&nbsp;
                    </div>
              </div>
            </div>
          </div>
        </b-container>
      </b-modal>
      <!--用戶確認視窗-->
      <b-modal ref="checkUser" hide-footer title="請輸入使用者密碼">
        <div class="d-block">
          <div class="col-lg-12 col-12 mb-3">
            <div class="row col-lg-12">
                <label>使用者密碼：</label>
                <input type='password' v-model='ch_password' class='form-control' splaceholder='請輸入使用者密碼' >
            </div>
          </div>
          <div class="cog-lg-12">
              <div class="row float-right cog-lg-12">
                <b-btn variant="primary"  @click="updateMobile()">儲存</b-btn>&nbsp;
                <b-btn variant="secondary"  @click="cancelUpdateMobile()">取消</b-btn>&nbsp;
              </div>
          </div>
        </div>
      </b-modal>
      <!--用戶確認視窗-->
      <b-modal ref="MobileUpdateLog" hide-footer :title="modal_log_title" size="lg">
        <div class="d-block">
          <table  id="mytable" class="table table-bordred table-striped mt-2">
            <tr>
              <th>項次</th>
              <th>修改前</th>
              <th>修改後</th>
              <th>修改時間</th>
              <th>修改人員帳號</th>
              <th>修改人員姓名</th>
            </tr>
            <tr v-for="(v,index) in Loglist" :key="v.ID">
              <td>{{index + 1}}</td>
              <td>{{v.BeforeValue}}</td>
              <td>{{v.AfterValue}}</td>
              <td>{{v.CreatedAt|formatDate}}</td>
              <td>{{v.UpdatedAccount}}</td>
              <td>{{v.UpdatedName}}</td>
            </tr>
          </table>
        </div>
      </b-modal>
      <!--刪除會員前要輸入密碼-->
      <b-modal size="lg" ref="checkDelete" hide-footer title="確定要刪除會員??請輸入使用者密碼與原因">
        <div class="d-block">
          <div class="col-lg-12 col-12 mb-3">
            <div class="row col-lg-12">
                <label>使用者密碼：</label>
                <input type='password' v-model='del_password' class='form-control' splaceholder='請輸入使用者密碼' >
            </div>
          </div>
          <div class="col-lg-12 col-12 mb-3">
            <div class="row col-lg-12">
                <label>刪除會員原因：</label>
                <input type='memo' v-model='del_memo' class='form-control' splaceholder='請輸入刪除會員原因' maxlength="100">
            </div>
          </div>
          <div class="col-lg-12 col-12 mb-3">
            <div class="row col-lg-12">
                請確認須為「會員本人」要求刪除，才可執行刪除，如遇會員欲註冊的帳號已被使用的問題，請洽系統管理員。<br /><br/>
                      按下［確認刪除］後，將刪除會員所有資料，包含手機號碼，刪除資訊如下－<br />
                      1. 會員資料、信用卡資料：整筆紀錄刪除。<br />
                      2. 向tappay註銷綁卡。<br />
                      3. 點數紀錄：刪除會員姓名、手機號碼，僅留存會員編號。<br />
                      4. 會員票券表：<br />
                      &nbsp;&nbsp;①刪除會員姓名、手機號碼，僅留存會員編號。<br />
                      &nbsp;&nbsp;②將可用的票券改成已到期，並於會員姓名欄位備註[會員刪除失效]。<br />
                      &nbsp;&nbsp;③將失效的票券同步給POS。<br />
                      5.訂單資料：僅有會員編號。
            </div>
            <div class="row col-lg-12">
              <div class="col-lg-8">
              </div>
              <div class="col-lg-4">
                <b-btn class="cog-lg-2 text-white btn btn-danger" variant="success"  @click="Delete('N')">刪除</b-btn>
              </div>
            </div>
          </div>
        </div>
      </b-modal>
    </div>
</template>
<script>
import miniToastr from 'mini-toastr'
import Vue from 'vue'
import VueForm from 'vue-form'
import options from 'validations'
import { ClientTable } from 'vue-tables-2'
import axios from 'axios'
import {API_URL} from '../../../store/root.js'
import { getFunctionPermission } from '@/js/LoginUserFunction.js'
Vue.use(VueForm, options)
Vue.use(ClientTable, {}, false)
export default {
  name: 'add_user',
  data () {
    return {
      formstate: {},
      formstate1: {},
      city: [],
      districts: [],
      districts1: [],
      phonetype: false,
      giftcertificate: {
        keyword: '',
        currentPage: 1,
        totalrows: 0,
        rows: 20,
        startRowNum: 0,
        endRowNum: 0
      },
      giftcertificatelist: [],
      memberreference: {
        keyword: '',
        currentPage: 1,
        totalrows: 0,
        rows: 20,
        startRowNum: 0,
        endRowNum: 0
      },
      memberreferencelist: [],
      member: {},
      model1: {},
      Status: 1,
      ticketcount: 4,
      ticketcount1: 2,
      old_file: '',
      rowdata: [],
      columndata: [],
      rowdata1: [],
      columndata1: [],
      FunctionPermission: 0,
      newMobile: '',
      valid_newMobile: '',
      valid_errMsg: false,
      ch_password: '',
      del_password: '',
      del_memo: '',
      modal_log_title: '',
      Loglist: [],
      hasLogList: false
    }
  },
  computed: {
    isBasicMember() {
      return this.model1.GradeID === 10
    },
    isPremReferralCodeEditOnly() {
      return this.FunctionPermission === 5
    },
    disabledEditFields() {
      return {
          name1: this.isBasicMember || this.isPremReferralCodeEditOnly,
          gender: this.isBasicMember || this.isPremReferralCodeEditOnly,
          dob: this.isBasicMember || this.isPremReferralCodeEditOnly,
          email: this.isBasicMember || this.isPremReferralCodeEditOnly,
          city: this.isBasicMember || this.isPremReferralCodeEditOnly,
          erea: this.isBasicMember || this.isPremReferralCodeEditOnly,
          address: this.isBasicMember || this.isPremReferralCodeEditOnly,
          OneAssetsSn: this.isBasicMember,
          member_status: this.isPremReferralCodeEditOnly,
          storeoay_black: this.isPremReferralCodeEditOnly,
      }
    },
    hideEditFields() {
      return {
          edit_mobile: this.isPremReferralCodeEditOnly,
      }
    }
  },
  methods: {
    upload_pic () {
      this.$refs.user_image.processQueue()
    },
    uploaded () {
      console.log('uploaded')
    },
    onSubmit: function () {
      this.upload_pic()
      if (!this.formstate.$invalid) {
        this.$router.push('/add_user')
      }
    },
    editcontact (item) {
      this.model1 = {}
      this.model1.ID = item.ID
      this.model1.Address = item.Address
      this.model1.AvailableBonus = item.AvailableBonus
      this.model1.Birthday = item.Birthday
      this.model1.BlackListComment = item.BlackListComment
      this.model1.City = item.City
      this.model1.Accumulated = item.Accumulated
      this.model1.District = item.District
      this.model1.Email = item.Email
      this.model1.Gender = item.Gender
      this.model1.GradeID = item.GradeID
      this.model1.GradeText = item.GradeText
      this.model1.LastUpdateState = item.LastUpdateState
      this.model1.Mobile = item.Mobile
      this.model1.Name = item.Name
      this.model1.ReferralCode = item.ReferralCode
      this.model1.Status = item.Status
      this.Status = this.model1.Status
      this.model1.UpgradeAt = item.UpgradeAt
      this.model1.YearExpiredBonus = item.YearExpiredBonus
      this.model1.CreatedAt = item.CreatedAt
      this.model1.StorepayBlackStatus = item.StorepayBlackStatus
      var mb = this.model1
      this.city.forEach(function (e) {
        if (e.city === mb.City) {
          mb.City = e
          this.districts1 = mb.City.districts
          var mb1 = mb
          mb = mb1
        }
      })
      this.districts1 = item.City.districts
      this.$refs.editcontact.show()
    },
    updateContact (e) {
      if (this.$route.params.memberid === undefined) {
        this.$router.push({ name: 'member_info_list' })
        return
      }
      var Birthday = ''
      if (e.Birthday.replace(/-/g, '') !== '') {
        Birthday = e.Birthday.slice(0, 4) + '' + e.Birthday.slice(5, 7) + '' + e.Birthday.slice(8, 10)
      }
      if (e.GradeID !== 10) {
        const patternEmail = /^[a-zA-Z0-9._%+\\-]+@[a-zA-Z0-9.\\-]+\.[a-z]{2,4}$/
        const patternReferralCode = /^[A-Z0-9]+$/
        if (e.Name === '') {
          miniToastr.error('姓名不可為空值')
          return
        } else if (e.Email !== '' && !patternEmail.test(e.Email)) {
          miniToastr.error('email格式錯誤')
          return
        } else if (e.ReferralCode === '') {
          miniToastr.error('推薦碼不可為空值')
          return
        } else if (e.ReferralCode.length > 20) {
          miniToastr.error('推薦碼長度錯誤')
          return
        } else if (!patternReferralCode.test(e.ReferralCode)) {
          miniToastr.error('推薦碼請設定英文大寫或數字')
          return
        }
      }
      var BlackListComment = e.BlackListComment.trim()
      if ((this.Status === '2' || this.Status === 2) && BlackListComment === '') {
        miniToastr.error('沒輸入黑名單說明')
        return
      } else if (this.Status === '1' || this.Status === 1) {
        BlackListComment = ''
      }
      if (this.phonetype) {
        return
      }
      
      this.$parent.Loading = true
      return axios.post(API_URL + '/web/update/member/v1', {
        id: e.ID,
        name: e.Name,
        birthday: Birthday,
        mobile: e.Mobile,
        gender: e.Gender,
        email: e.Email,
        city: e.City.city,
        district: e.District,
        address: e.Address,
        referralcode: e.ReferralCode,
        status: parseInt(this.Status),
        blacklistcomment: BlackListComment,
        storepayblackstatus: parseInt(e.StorepayBlackStatus)
      })
        .then((response) => {
          if (response.data.result === '0000') {
            this.getmemberdata()
            this.getgiftcertificate(1)
            this.getmemberreference(1)
            this.$refs.editcontact.hide()
            this.$store.commit('TOKEN', response.data.jwt)
          } else if (response.data.result === '0006') {
            this.$parent.logOut(true, true)
            this.$refs.editcontact.hide()
          } else {
            miniToastr.error(response.data.message, '資料讀取異常')
            console.log(response.data.message)
            this.$refs.editcontact.hide()
          }
          this.$parent.Loading = false
        })
        .catch((error) => {
          console.log('CATCH')
          console.log(error)
          miniToastr.error(error.message, '資料讀取異常')
          this.$parent.Loading = false
        })
    },
    cancel () {
      this.$refs.editcontact.hide()
    },
    dateFormatter (date) {
      var d = new Date(date)
      var chkDate = new Date('2000-01-01')
      if (d < chkDate) {
        // 代表傳送過來的time.Time為空值
        return ''
      }
      var year = d.getFullYear()
      var month = d.getMonth() + 1
      var day = d.getDate() < 10 ? '0' + d.getDate() : '' + d.getDate()
      var hour = d.getHours() < 10 ? '0' + d.getHours() : '' + d.getHours()
      var minutes = d.getMinutes() < 10 ? '0' + d.getMinutes() : '' + d.getMinutes()
      var seconds = d.getSeconds() < 10 ? '0' + d.getSeconds() : '' + d.getSeconds()
      if (month < 10) {
        month = '0' + month
      }
      return year + '/' + month + '/' + day + ' ' + hour + ':' + minutes + ':' + seconds
    },
    getmemberdata () {
      if (this.$route.params.memberid === undefined) {
        this.$router.push({ name: 'member_info_list' })
        return
      }
      this.$parent.Loading = true
      return axios.post(API_URL + '/web/memberone/v1', {
        memberid: this.$route.params.memberid,
        mobile: ''
      })
        .then((response) => {
          if (response.data.result === '0000') {
            this.member = response.data.member
            console.log(this.member)
            var mb = this.member
            mb.Birthday = mb.Birthday.slice(0, 4) + '-' + mb.Birthday.slice(4, 6) + '-' + mb.Birthday.slice(6, 8)
            if (mb.UpgradeAt !== '') {
              mb.UpgradeAt = mb.UpgradeAt.slice(0, 4) + '/' + mb.UpgradeAt.slice(4, 6) + '/' + mb.UpgradeAt.slice(6, 8) + ' ' + mb.UpgradeAt.slice(8, 10) + ':' + mb.UpgradeAt.slice(10, 12) + ':' + mb.UpgradeAt.slice(12, 14)
            }
            mb.CreatedAt = this.dateFormatter(mb.CreatedAt)
            mb.StatusUpdatedAt = this.dateFormatter(mb.StatusUpdatedAt)
            mb.StorepayBlackStatusUpdatedAt = this.dateFormatter(mb.StorepayBlackStatusUpdatedAt)
            this.city.forEach(function (e) {
              if (e.city === mb.City) {
                mb.City = e
                var mb1 = mb
                mb = mb1
              }
            })
            this.$store.commit('TOKEN', response.data.jwt)
            this.getMobileUpdateLogList()
          } else if (response.data.result === '0006') {
            this.$parent.logOut(true, true)
          } else {
            miniToastr.error(response.data.message, '會員資料讀取異常')
            console.log(response.data.message)
            console.log(response.data.result)
          }
          this.$parent.Loading = false
        })
        .catch((error) => {
          console.log('CATCH')
          console.log(error)
          miniToastr.error(error.message, '會員資料讀取異常')
          this.$parent.Loading = false
        })
    },
    getpost1 () {
      this.$parent.Loading = true
      return axios.post(API_URL + '/web/post1/v1', {
      })
        .then((response) => {
          if (response.data.result === '0000') {
            this.city = response.data.data
            var mb = this.member
            this.city.forEach(function (e) {
              if (e.city === mb.City) {
                mb.City = e
                var mb1 = mb
                mb = mb1
              }
            })
            this.$store.commit('TOKEN', response.data.jwt)
          } else if (response.data.result === '0006') {
            this.$parent.logOut(true, true)
          } else {
            miniToastr.error(response.data.message, '資料讀取異常')
            console.log(response.data.message)
          }
          this.$parent.Loading = false
        })
        .catch((error) => {
          console.log('CATCH')
          console.log(error)
          miniToastr.error(error.message, '資料讀取異常')
          this.$parent.Loading = false
        })
    },
    show (city) {
      this.model1.District = ''
      this.districts1 = city.districts
    },
    getgiftcertificate (currentPage) {
      this.$parent.Loading = true
      return axios.post(API_URL + '/web/member/giftcertificate/v1', {
        memberid: this.$route.params.memberid,
        keyword: this.giftcertificate.keyword,
        toPage: currentPage,
        perPage: this.giftcertificate.rows
      })
        .then((response) => {
          if (response.data.result === '0000') {
            this.giftcertificatelist = response.data.membergiftcertificatelist
            this.giftcertificate.totalrows = (response.data.totalRows === undefined) ? 0 : response.data.totalRows
            this.giftcertificate.currentPage = response.data.pageNumber
            this.$store.commit('TOKEN', response.data.jwt)
            this.giftcertificate.currentPage = currentPage
            this.giftcertificate.startRowNum = (response.data.totalRows === undefined || response.data.totalRows === 0) ? 0 : this.giftcertificate.rows * (this.giftcertificate.currentPage - 1) + 1
            this.giftcertificate.endRowNum = (response.data.totalRows === undefined || response.data.totalRows === 0) ? 0 : (this.giftcertificate.rows > response.data.totalRows) ? response.data.totalRows : (this.giftcertificate.currentPage * this.giftcertificate.rows) >= response.data.totalRows ? response.data.totalRows : this.giftcertificate.currentPage * this.giftcertificate.rows
          } else if (response.data.result === '0006') {
            this.$parent.logOut(true, true)
          } else {
            miniToastr.error(response.data.message, '查詢失敗')
            console.log(response.data.message)
          }
          this.$parent.Loading = false
        })
        .catch((error) => {
          console.log('CATCH')
          console.log(error)
          miniToastr.error(error.message, '查詢失敗')
          this.$parent.Loading = false
        })
    },
    getmemberreference (currentPage) {
      this.$parent.Loading = true
      return axios.post(API_URL + '/web/member/reference/v1', {
        memberid: this.$route.params.memberid,
        keyword: this.memberreference.keyword,
        toPage: currentPage,
        perPage: this.memberreference.rows
      })
        .then((response) => {
          if (response.data.result === '0000') {
            this.memberreferencelist = response.data.memberreferencelist
            this.$store.commit('TOKEN', response.data.jwt)
            this.memberreference.currentPage = currentPage
            this.memberreference.totalrows = (response.data.totalRows === undefined) ? 0 : response.data.totalRows
            this.memberreference.startRowNum = (response.data.totalRows === undefined || response.data.totalRows === 0) ? 0 : this.memberreference.rows * (this.memberreference.currentPage - 1) + 1
            this.memberreference.endRowNum = (response.data.totalRows === undefined || response.data.totalRows === 0) ? 0 : (this.memberreference.rows > response.data.totalRows) ? response.data.totalRows : (this.memberreference.currentPage * this.memberreference.rows) >= response.data.totalRows ? response.data.totalRows : this.memberreference.currentPage * this.memberreference.rows
          } else if (response.data.result === '0006') {
            this.$parent.logOut(true, true)
          } else {
            miniToastr.error(response.data.message, '查詢失敗')
            console.log(response.data.message)
          }
          this.$parent.Loading = false
        })
        .catch((error) => {
          console.log('CATCH')
          console.log(error)
          miniToastr.error(error.message, '查詢失敗')
          this.$parent.Loading = false
        })
    },
    check_count (event) {
      var value = event.target.value
      if (!/^\+?[0-9]*$/.test(value)) {
        this.model.phonetype = true
      } else {
        this.model.phonetype = false
      }
    },
    editmobile () {
      this.newMobile = ''
      this.$refs.editmobile.show()
    },
    canceleditmobile () {
      this.newMobile = ''
      this.$refs.editmobile.hide()
    },
    checkMobile () {
      this.valid_errMsg = false
      var numReg = /^[0-9]+$/
      var numRe = new RegExp(numReg)
      if (!this.newMobile) {
        this.valid_errMsg = true
        this.valid_newMobile = '此欄位必填'
      } else if (this.newMobile === this.member.Mobile) {
        this.valid_errMsg = true
        this.valid_newMobile = '新舊手機號碼相同'
      } else if (!numRe.test(this.newMobile) || this.newMobile.length !== 10 || this.newMobile.substr(0, 2) !== '09') {
        this.valid_errMsg = true
        this.valid_newMobile = '手機格式不符。範例:0910123456'
      } else {
        this.valid_errMsg = false
        this.valid_newMobile = ''
      }
      if (this.valid_errMsg) {
        this.$parent.verificationErrMsg()
      } else {
        this.$refs.confirmMobile.show()
      }
    },
    cancelConfirmMobile () {
      this.$refs.confirmMobile.hide()
    },
    checkUser () {
      this.$refs.checkUser.show()
      this.ch_password = ''
    },
    cancelCheckUser () {
      this.$refs.confirmMobile.hide()
      this.$refs.checkUser.hide()
    },
    updateMobile () {
      if (this.$parent.Loading === true) {
        return
      }
      this.$parent.Loading = true
      return axios.post(API_URL + '/web/update/member/mobile/v1', {
        password: this.ch_password,
        memberid: this.$route.params.memberid,
        mobile: this.newMobile
      })
        .then((response) => {
          if (response.data.result === '0000') {
            this.cancelUpdateMobile()
            miniToastr.success('手機號碼修改成功')
            this.getmemberdata()
          } else if (response.data.result === '0101') {
            miniToastr.error('密碼錯誤')
          } else if (response.data.result === '0201') {
            miniToastr.error('手機號碼已存在，請確認')
            this.cancelCheckUser()
          } else if (response.data.result === '0006') {
            this.$parent.logOut(true, true)
          } else {
            miniToastr.error(response.data.message, '修改手機號碼失敗')
            console.log(response.data.message)
          }
          this.$parent.Loading = false
        })
        .catch((error) => {
          console.log('CATCH')
          console.log(error)
          this.$parent.Loading = false
          miniToastr.error(error.message, '修改手機號碼失敗')
        })
    },
    cancelUpdateMobile () {
      this.canceleditmobile()
      this.cancelCheckUser()
    },
    showMobileUpdateLog () {
      this.$refs.MobileUpdateLog.show()
      this.modal_log_title = '會員' + this.member.Name + '手機號碼修改紀錄'
    },
    // 取得手機號碼修改紀錄
    getMobileUpdateLogList () {
      this.$parent.Loading = true
      return axios.post(API_URL + '/web/member/updatelog/v1', {
        memberid: this.$route.params.memberid
      })
        .then((response) => {
          if (response.data.result === '0000') {
            this.Loglist = response.data.data
            if (this.Loglist.length > 0) {
              this.hasLogList = true
            } else {
              this.hasLogList = false
            }
            this.$store.commit('TOKEN', response.data.jwt)
          } else if (response.data.result === '0006') {
            this.$parent.logOut(true, true)
          } else {
            console.log(response)
            miniToastr.error(response.data.message, '查詢失敗')
            console.log(response.data.message)
          }
          this.$parent.Loading = false
        })
        .catch((error) => {
          console.log('CATCH')
          console.log(error)
          this.$parent.Loading = false
        })
    },
    checkDelete () {
      this.del_password = ''
      this.del_memo = ''
      this.$refs.checkDelete.show()
    },
    Delete (delmode) {
      if (this.del_password === '') {
        miniToastr.error('請輸入您的密碼')
        return
      }
      if (this.del_memo === '') {
        miniToastr.error('請輸入刪除會員原因')
        return
      }
      this.$parent.Loading = true
      return axios.post(API_URL + '/web/member/delete/v1', {
        password: this.del_password,
        memberid: this.$route.params.memberid,
        mode: delmode,
        memo: this.del_memo
      })
        .then((response) => {
          if (response.data.result === '0000') {
            miniToastr.success('會員刪除成功')
            this.$router.push({
              name: 'member_info_list',
              params: { search: this.$route.params.search }
            })
          } else if (response.data.result === '0101') {
            miniToastr.error('密碼錯誤')
          } else if (response.data.result === '0006') {
            this.$parent.logOut(true, true)
          } else {
            miniToastr.error(response.data.message, '會員刪除失敗')
          }
          this.$parent.Loading = false
        })
        .catch((error) => {
          miniToastr.error(error, '錯誤訊息')
          this.$parent.Loading = false
        })
    },
    setdate () {
      var date = new Date()
      var year = date.getFullYear()
      var mon = date.getMonth() + 1
      var day = date.getDate()

      var date2 = new Date(date.setDate(date.getDate() - 90))
      var year2 = date2.getFullYear()
      var mon2 = date2.getMonth() + 1
      var day2 = date2.getDate()

      if (mon < 10) {
        mon = '0' + mon
      }
      if (day < 10) {
        day = '0' + day
      }
      if (mon2 < 10) {
        mon2 = '0' + mon2
      }
      if (day2 < 10) {
        day2 = '0' + day2
      }
      this.model1.sdate = year2 + '-' + mon2 + '-' + day2
      this.model1.edate = this.today = year + '-' + mon + '-' + day
    }
  },
  mounted: function () {

  },
  destroyed: function () {

  },
  beforeMount: function () {
    this.getmemberdata()
    this.getpost1()
    this.getgiftcertificate(1)
    this.getmemberreference(1)
  },
  filters: {
    formatDate: function (date) {
      var d = new Date(date)
      var year = d.getFullYear()
      var month = d.getMonth() + 1
      if (month < 10) {
        month = '0' + month
      }
      var day = d.getDate() < 10 ? '0' + d.getDate() : '' + d.getDate()
      var hour = d.getHours() < 10 ? '0' + d.getHours() : '' + d.getHours()
      var minutes = d.getMinutes() < 10 ? '0' + d.getMinutes() : '' + d.getMinutes()
      var seconds = d.getSeconds() < 10 ? '0' + d.getSeconds() : '' + d.getSeconds()
      return year + '/' + month + '/' + day + ' ' + hour + ':' + minutes + ':' + seconds
    },
    YYYYMMDD: function (date) {
      var d = new Date(date)
      var year = d.getFullYear()
      var month = d.getMonth() + 1
      if (month < 10) {
        month = '0' + month
      }
      var day = d.getDate() < 10 ? '0' + d.getDate() : '' + d.getDate()
      return year + '/' + month + '/' + day
    }
  },
  created () {
    this.FunctionPermission = getFunctionPermission('F07') // 功能權限 帶入功能代碼
    if (this.FunctionPermission < 1) {
      this.$router.push({name: 'name'})
    }
  }
}
</script>
<style scoped>
    .align-left{
        float: left;
    }
    .align-right{
        float: right;
    }
    .box-shadow {
        box-shadow: 0px 0px 1px 1px #cfcfcf;
    }
</style>



// WEBPACK FOOTER //
// src/pages/member/info/Edit.vue